var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('modal',{staticClass:"ticketing-info-modal",attrs:{"title":_vm.title,"first-button-text":_vm.buttonText,"first-button-action":_vm.closeModal,"icon":_vm.icon,"is-loading":_vm.loading,"dark-theme":""},on:{"close":_vm.closeModal}},[(_vm.additionalText)?_c('div',[_vm._v(" "+_vm._s(_vm.additionalText)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }